import { useQuery } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { REPOSITORIES_SUMMARY_QUERY_KEY } from "../constants";
const NO_SESSION_EXT = { requestShouldExtendSession: false };
const fetchSummary = () => DataTieringRepositories.allRepositories(void 0, NO_SESSION_EXT).then(
  (states) => states.map((state) => ({ ...state, repository: state.repository }))
);
const hasCredentialProblem = ({ credential_status }) => credential_status === "missing" || credential_status === "invalid";
const useRepositoriesSummary = ({ refetchInterval } = {}) => {
  var _a, _b;
  const { data, isLoading, isError } = useQuery({
    queryKey: REPOSITORIES_SUMMARY_QUERY_KEY,
    queryFn: () => defaultOnError(
      fetchSummary(),
      "Loading Warm Tier repositories failed with status",
      "Could not load Warm Tier repositories."
    ),
    refetchInterval: refetchInterval || void 0
  });
  return {
    summary: {
      data,
      isLoading,
      isError
    },
    configuredCount: (_a = data == null ? void 0 : data.length) != null ? _a : 0,
    credentialProblemsCount: (_b = data == null ? void 0 : data.filter(hasCredentialProblem).length) != null ? _b : 0
  };
};
export default useRepositoriesSummary;
